import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObj: {
    DocType: "",
    DocTypeName: "",
    DocNo: 0,
    Date: new Date(),
    Loc: "",
    LocName: "",
    LocTo: "",
    LocNameTo: "",
    A_DocStat: "ENTER",
  },
  SummaryObj: {
    loc: "",
    locTo: "",
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
    status: "Pending",
  },
};

const SliceStockTransferReceipt = createSlice({
  name: "SliceStockTransferReceipt",
  initialState: { value: initialState },

  reducers: {
    Set_SliceStockTransferReceipt_HeadObj: (state, action) => {
      state.value.HeadObj = action.payload;
    },
    Set_SliceStockTransferReceipt_HeadObj_Init: (state, action) => {
      state.value.HeadObj = initialState.HeadObj;
    },

    Set_SliceStockTransferReceipt_SummaryObj: (state, action) => {
      state.value.SummaryObj = action.payload;
    },
    Slice_StockTransferReceipt_Init: (state) => {
      state.value = initialState;
    },

    Set_SliceStockTransferReceipt_HeadObject_A_DocStat: (state, action) => {
      state.value.HeadObj.A_DocStat = action.payload.A_DocStat;
    },
    Set_SliceStockTransferReceipt_HeadObject_SheetNo_A_DocStat: (
      state,
      action
    ) => {
      state.value.HeadObj.SheetNo = action.payload.SheetNo;
      state.value.HeadObj.A_DocStat = action.payload.A_DocStat;
    },
  },
});

export const {
  Set_SliceStockTransferReceipt_HeadObj,
  Set_SliceStockTransferReceipt_SummaryObj,
  Set_SliceStockTransferReceipt_HeadObject_A_DocStat,
  Set_SliceStockTransferReceipt_HeadObject_SheetNo_A_DocStat,
  Slice_StockTransferReceipt_Init,
  Set_SliceStockTransferReceipt_HeadObj_Init,
} = SliceStockTransferReceipt.actions;
export default SliceStockTransferReceipt.reducer;
